import checkUsersAge from '../checkUsersAge';

export default function validateRequired(birthday, value){
    if (checkUsersAge(birthday)) {
        return !!value;
    }
    return true;
}